import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ChatBotContext = createContext();

export const useChatBot = () => {
  const context = useContext(ChatBotContext);
  if (!context) {
    throw new Error('useChatBot must be used within a ChatBotProvider');
  }
  return context;
};

export const ChatBotProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialMessage, setInitialMessage] = useState(null);
  const pageContentRef = useRef(null);

  const openWithMessage = useCallback((message) => {
    setInitialMessage(message);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const clearInitialMessage = useCallback(() => {
    setInitialMessage(null);
  }, []);

  const setPageContent = useCallback((content) => {
    pageContentRef.current = content;
  }, []);

  const getPageContent = useCallback(() => {
    return pageContentRef.current;
  }, []);

  const clearPageContent = useCallback(() => {
    pageContentRef.current = null;
  }, []);

  return (
    <ChatBotContext.Provider value={{ 
      isOpen, setIsOpen, initialMessage, openWithMessage, close, clearInitialMessage,
      setPageContent, getPageContent, clearPageContent
    }}>
      {children}
    </ChatBotContext.Provider>
  );
};
